import { Chip } from "@kirvanobr/chip";
import { Typography } from "@kirvanobr/typography";

import { StatusChipProps } from "./StatusChip.types";
import { styles as S } from "./StatusChip.styles";

export const StatusChip = ({ color, text, typographyProps, width, ...props }: StatusChipProps) => {
  return (
    <Chip
      className="border"
      variant="outlined"
      color={color}
      radius="sm"
      size="lg"
      classNames={{ content: S({ width }).base(), base: "rounded-[4px]" }}
      {...props}
    >
      <Typography size="t5" weight="medium" className={S().text()} {...typographyProps}>
        {text}
      </Typography>
    </Chip>
  );
};
